<div class="incident-type-edit">
    <div class="actions">
        @if (showSavedButton) {
            <cerrix-button
                color="accent-light"
                type="flat"
                [dataUiid]="'standing-data-incident-type-saved-button'"
                [disabled]="true"
                ><ng-container>Saved!</ng-container
                ><mat-icon fontSet="material-symbols-outlined">check_small</mat-icon></cerrix-button
            >
        } @else {
            <cerrix-button
                [disabled]="!form.dirty || !form.valid || loading"
                color="primary-light"
                type="stroked"
                [dataUiid]="'standing-data-incident-type-save-button'"
                (click)="onSave()"
                ><ng-container>Save</ng-container
                ><mat-icon fontSet="material-symbols-outlined">check_small</mat-icon></cerrix-button
            >
        }

        <cerrix-button
            (click)="onDelete()"
            [dataUiid]="'standing-data-incident-type-delete-button'"
            [disabled]="!form.value.id || loading || predefined"
            color="error"
            >Delete</cerrix-button
        >
    </div>

    @if (loading) {
        <div style="flex: 1">
            <div style="margin-top: -74px" class="fancy-loader submodule"></div>
        </div>
    } @else {
        <form class="form-container" [formGroup]="form">
            <cerrix-title
                placeholder="Enter incident type name"
                size="large"
                [clipText]="true"
                formControlName="name"
                [required]="true"
                [dataUiid]="'standing-data-incident-type-title-input'"
            ></cerrix-title>
            <mat-tab-group
                [attr.data-uiid]="'standing-data-incident-type-tab-group'"
                [mat-stretch-tabs]="false"
                [dynamicHeight]="true"
            >
                <mat-tab>
                    <ng-template mat-tab-label>
                        <span [attr.data-uiid]="'standing-data-incident-type-tab-input-fields'"
                            >Input fields</span
                        >
                    </ng-template>
                    <div class="content">
                        <div class="section-container">
                            <div>
                                <div class="section-header">
                                    <cerrix-title
                                        value="Details"
                                        [editable]="false"
                                        [focus]="false"
                                    ></cerrix-title>
                                </div>
                                <mat-card appearance="outlined" class="custom-fields-card">
                                    <div
                                        formArrayName="customFields"
                                        class="custom-fields-list"
                                        cdkDropList
                                        [id]="'section-detail-container'"
                                        cdkDropListOrientation="mixed"
                                        (cdkDropListDropped)="
                                            customFieldsReorder($event)
                                        "
                                    >
                                        @for (
                                            customFieldForm of detailCustomFieldsForm.controls;
                                            track $index
                                        ) {
                                            <div
                                                class="custom-field-item"
                                                [class.full-width]="
                                                    fullWidthCustomTypes.includes(
                                                        customFieldForm.get('customFieldType').value
                                                    )
                                                "
                                                cdkDrag
                                            >
                                                <ng-container
                                                    [ngTemplateOutlet]="customFieldsTemplate"
                                                    [ngTemplateOutletContext]="{
                                                        cfIndex: $index,
                                                        customFieldType:
                                                            customFieldForm.get('customFieldType')
                                                                .value,
                                                        sectionIndex: undefined,
                                                        customFieldForm: customFieldForm,
                                                    }"
                                                ></ng-container>
                                            </div>
                                        }
                                    </div>

                                    <div class="action-container">
                                        <cerrix-button
                                            size="small"
                                            [dataUiid]="
                                                'standing-data-incident-type-add-custom-field-button'
                                            "
                                            (click)="editCustomField(undefined)"
                                        >
                                            <mat-icon>add</mat-icon>
                                            <ng-container>Add new field</ng-container>
                                        </cerrix-button>
                                    </div>
                                </mat-card>
                            </div>
                        </div>

                        <div
                            cdkDropList
                            (cdkDropListDropped)="sectionReorder($event)"
                            class="section-draggable-area"
                            formArrayName="incidentTypeSections"
                            cdkDropListGroup
                        >
                            @for (
                                section of sectionsForm.controls;
                                track section;
                                let sectionIndex = $index
                            ) {
                                <div #section class="section-container" cdkDrag>
                                    <div [formGroupName]="sectionIndex">
                                        <div class="section-header">
                                            @if (!section.get("isPredefined").value) {
                                                <cerrix-title
                                                    class="title"
                                                    placeholder="Section"
                                                    formControlName="name"
                                                    [dataUiid]="
                                                        'standing-data-incident-type-section-title-' +
                                                        sectionIndex
                                                    "
                                                ></cerrix-title>
                                            } @else {
                                                <cerrix-title
                                                    class="title"
                                                    placeholder="Section"
                                                    [value]="section.get('name').value"
                                                    [editable]="false"
                                                    [dataUiid]="
                                                        'standing-data-incident-type-section-title-' +
                                                        sectionIndex
                                                    "
                                                ></cerrix-title>
                                            }
                                            <mat-button
                                                class="action-icon drag-pan"
                                                mat-icon-button
                                                cdkDragHandle
                                                [attr.data-uiid]="
                                                    'standing-data-incident-type-section-drag-handle-' +
                                                    sectionIndex
                                                "
                                            >
                                                <mat-icon fontSet="material-symbols-outlined"
                                                    >drag_pan</mat-icon
                                                >
                                            </mat-button>
                                            @if (!section.get("isPredefined").value) {
                                                <mat-button
                                                    class="action-icon"
                                                    mat-icon-button
                                                    [matMenuTriggerFor]="menu"
                                                >
                                                    <mat-icon>more_vert</mat-icon>
                                                </mat-button>
                                            }
                                            <mat-menu #menu="matMenu" class="section-menu">
                                                <button
                                                    mat-menu-item
                                                    [attr.data-uiid]="
                                                        'standing-data-incident-type-edit-section-button-' +
                                                        sectionIndex
                                                    "
                                                    (click)="deleteSection(sectionIndex)"
                                                    class="section-menu-button"
                                                >
                                                    <mat-icon
                                                        class="section-menu-icon"
                                                        fontSet="material-symbols-outlined"
                                                        >delete</mat-icon
                                                    >
                                                    <span>Delete</span>
                                                </button>
                                                <button
                                                    mat-menu-item
                                                    [attr.data-uiid]="
                                                        'standing-data-incident-type-duplicate-section-button-' +
                                                        sectionIndex
                                                    "
                                                    (click)="duplicateSection(sectionIndex)"
                                                    class="section-menu-button"
                                                >
                                                    <mat-icon
                                                        class="section-menu-icon"
                                                        fontSet="material-symbols-outlined"
                                                        >content_copy</mat-icon
                                                    >
                                                    <span>Duplicate</span>
                                                </button>
                                            </mat-menu>
                                        </div>
                                        <mat-card appearance="outlined" class="custom-fields-card">
                                            <div
                                                formArrayName="customFields"
                                                class="custom-fields-list"
                                                cdkDropList
                                                [id]="'section-' + sectionIndex + '-container'"
                                                cdkDropListOrientation="mixed"
                                                (cdkDropListDropped)="
                                                    customFieldsReorder($event)
                                                "
                                            >
                                                @for (
                                                    customFieldForm of getSectionCustomFieldsForm(
                                                        section
                                                    ).controls;
                                                    track $index
                                                ) {
                                                    <div
                                                        class="custom-field-item"
                                                        [class.full-width]="
                                                            fullWidthCustomTypes.includes(
                                                                customFieldForm.get(
                                                                    'customFieldType'
                                                                ).value
                                                            )
                                                        "
                                                        cdkDrag
                                                    >
                                                        <ng-container
                                                            [ngTemplateOutlet]="
                                                                customFieldsTemplate
                                                            "
                                                            [ngTemplateOutletContext]="{
                                                                cfIndex: $index,
                                                                customFieldType:
                                                                    customFieldForm.get(
                                                                        'customFieldType'
                                                                    ).value,
                                                                sectionIndex: sectionIndex,
                                                                customFieldForm: customFieldForm,
                                                            }"
                                                        ></ng-container>
                                                    </div>
                                                }
                                            </div>
                                            <div class="action-container">
                                                <cerrix-button
                                                    size="small"
                                                    [dataUiid]="
                                                        'standing-data-incident-type-add-custom-field-button-' +
                                                        sectionIndex
                                                    "
                                                    (click)="editCustomField(sectionIndex)"
                                                >
                                                    <mat-icon>add</mat-icon>
                                                    <ng-container>Add new field</ng-container>
                                                </cerrix-button>
                                            </div>
                                        </mat-card>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>

                    <div class="footer">
                        <cerrix-button
                            (click)="addSection()"
                            [dataUiid]="'standing-data-incident-type-add-section-button'"
                            class="footer-button"
                            color="accent"
                        >
                            <mat-icon>add</mat-icon>
                            <ng-container>Add section</ng-container>
                        </cerrix-button>
                    </div>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <span [attr.data-uiid]="'standing-data-incident-type-tab-configuration'"
                            >Configuration</span
                        >
                    </ng-template>
                    @if (configurationTabSettings.assign.showSection) {
                        <div class="assign-config">
                            <cerrix-title value="Assign" [editable]="false"></cerrix-title>
                            @if (configurationTabSettings.assign.mailAddressesToInform) {
                                <cerrix-field-wrapper
                                    class="assign-item"
                                    type="secondary"
                                    label="Mail addresses to be informed"
                                    info="Mail addresses will receive an email when an incident of this specific type is created. Separate the mail addresses by a semi-colon ';'. "
                                    ><cerrix-input
                                        [dataUiid]="'standing-data-incident-type-email-input'"
                                        placeholder="Email placeholder"
                                        formControlName="emailAddresses"
                                    ></cerrix-input
                                ></cerrix-field-wrapper>
                            }
                        </div>
                    }
                    @if (configurationTabSettings.configuration.showSection) {
                        <div class="configuration-section">
                            <cerrix-title value="Configuration" [editable]="false"></cerrix-title>
                            @if (configurationTabSettings.configuration.archiveIncidentType) {
                                <div class="configuration-item">
                                    <div class="configuration-label">
                                        <cerrix-title
                                            value="Archive incident type"
                                            [editable]="false"
                                        ></cerrix-title>
                                        <span class="configuration-subtitle"
                                            >Hide this incident type in newer incident reports</span
                                        >
                                    </div>
                                    <cerrix-toggle
                                        formControlName="isArchived"
                                        labelOn="on"
                                        labelOff="off"
                                    ></cerrix-toggle>
                                </div>
                            }
                        </div>
                    }
                </mat-tab>
            </mat-tab-group>
        </form>
    }
</div>

<ng-template
    #customFieldsTemplate
    let-cfIndex="cfIndex"
    let-customFieldType="customFieldType"
    let-sectionIndex="sectionIndex"
    let-customFieldForm="customFieldForm"
>
    <div [formGroup]="customFieldForm">
        <div class="custom-field-header">
            <cerrix-title
                class="title"
                [value]="customFieldForm.get('name').value"
                [editable]="false"
            ></cerrix-title>
            <mat-button class="action-icon drag-pan" mat-icon-button cdkDragHandle>
                <mat-icon fontSet="material-symbols-outlined">drag_pan</mat-icon>
            </mat-button>
            <mat-button class="action-icon custom-field" mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon>more_vert</mat-icon>
            </mat-button>

            <mat-menu #menu="matMenu" class="section-menu">
                <button
                    mat-menu-item
                    [attr.data-uiid]="
                        'standing-data-incident-type-edit-custom-field-button-' + cfIndex
                    "
                    (click)="editCustomField(undefined, customFieldForm)"
                    class="section-menu-button"
                >
                    <mat-icon class="section-menu-icon" fontSet="material-symbols-outlined"
                        >edit</mat-icon
                    >
                    <span>Edit</span>
                </button>

                <button
                    mat-menu-item
                    [attr.data-uiid]="
                        'standing-data-incident-type-duplicate-custom-field-button-' + cfIndex
                    "
                    (click)="deleteCustomField(cfIndex, sectionIndex)"
                    class="section-menu-button"
                    [disabled]="customFieldForm.get('isPredefined').value"
                >
                    <mat-icon class="section-menu-icon" fontSet="material-symbols-outlined"
                        >delete</mat-icon
                    >
                    <span>Delete</span>
                </button>
            </mat-menu>
        </div>

        @if (customFieldType === 4) {
            <cerrix-textarea
                [placeholder]="customFieldForm.controls.placeholder.value"
                [disabled]="true"
            ></cerrix-textarea>
        } @else {
            <cerrix-input
                [placeholder]="customFieldForm.controls.placeholder.value"
                [disabled]="true"
            ></cerrix-input>
        }
    </div>
</ng-template>
